<template>
	<div class="flex flex-just-center rp">
		<div class="content flex flex-direction-column flex-align-center">
			<div class="top align-center">
				<img src="@/assets/public/rp-logo.png" alt="" />
				<p class="mt-16 yx-color-pure-1 font-bold" style="font-size: 24px">放单有热度，爆单快一步</p>
				<p class="mt-4 yx-color-blue-6" style="font-size: 14px">仅需3步，激活站外流量，助力销量增长</p>
			</div>
			<div class="bottom">
				<img src="@/assets/public/rp-flow-path.png" alt="" />
				<div class="flex flex-just-between flex-align-center pl-26 pr-26 mt-16">
					<div class="align-center">
						<p class="yx-color-pure-1 font-bold fz-16">第一步：添加顾问</p>
						<p class="fz-13 yx-color-blue-6 mt-4">添加热度专属放单顾问</p>
						<p class="fz-13 yx-color-blue-6 mt-4 mb-16">了解放单玩法</p>
						<el-button type="primary" @click="visible = true">查看微信</el-button>
					</div>
					<div class="align-center">
						<p class="yx-color-pure-1 font-bold fz-16">第二步：注册并授权</p>
						<p class="fz-13 yx-color-blue-6 mt-4">注册登录热度放单平台</p>
						<p class="fz-13 yx-color-blue-6 mt-4 mb-16">并授权团长账号</p>
						<el-button type="primary" @click="open('https://tz.redu.com/login')">前往登录</el-button>
					</div>
					<div class="align-center">
						<p class="yx-color-pure-1 font-bold fz-16">第三步：提报活动</p>
						<p class="fz-13 yx-color-blue-6 mt-4">进入热度放单平台</p>
						<p class="fz-13 yx-color-blue-6 mt-4 mb-16">提报热度星推团长活动</p>
						<el-button type="primary" @click="open('https://tz.redu.com/presentManage/present')">报名活动</el-button>
					</div>
				</div>
			</div>
		</div>
		<el-dialog title="专属放单顾问" width="400px" :before-close="beforeClose" :visible.sync="visible">
			<div class="flex flex-just-center">
				<img style="width: 160px" src="@/assets/public/rp-kefu.png" alt="" />
			</div>
		</el-dialog>
	</div>
</template>
<script>
export default {
	data() {
		return {
			visible: false,
		};
	},
	methods: {
		open(url) {
			window.open(url, '_blank');
		},
		beforeClose() {
			this.visible = false;
		},
	},
	mounted() {},
	components: {},
};
</script>
<style lang="less" scoped>
.content {
	width: 940px;
	margin-top: 50px;
	height: calc(100vh - 220px);
	.top {
		display: inline-block;
		img {
			width: 178px;
		}
	}
	.bottom {
		margin-top: 40px;
	}
}
.rp {
	/deep/ .el-dialog__body {
		padding: 40px !important;
	}
}
</style>
